export default __webpack_public_path__ + "static/media/document-protect-primary.d68cab07.svg";